import { API } from "@/services"

export const SIP_TRAFFIC_ENDPOINTS = {
  packetLossChart(params={}){
    return API.Axios.callstats.v1.request({
      url: `siptraffic/chart/packet-loss`,
      method: 'GET',
      params,
    })
  },
  jitterChart(params={}){
    return API.Axios.callstats.v1.request({
      url: `siptraffic/chart/jitter`,
      method: 'GET',
      params,
    })
  },
  RTTChart(params={}){
    return API.Axios.callstats.v1.request({
      url: `siptraffic/chart/rtt`,
      method: 'GET',
      params,
    })
  },
  fractionLossChart(params={}){
    return API.Axios.callstats.v1.request({
      url: `siptraffic/chart/fraction-loss`,
      method: 'GET',
      params,
    })
  },
}